import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <div>
      {/* Hero */}
      <section className="relative bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <h1 className="text-3xl md:text-5xl font-bold text-white">CONTACT US</h1>
        </div>
      </section>

      {/* Contact Info + Map */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
            {/* Left - Contact Info */}
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-6">
                ATLAS PRO SERVICES LLC
              </h2>

              <div className="flex items-start gap-4 mb-5">
                <span className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-gray-700"></i>
                </span>
                <div className="pt-1">
                  <a
                    href="tel:(360) 206-7120"
                    className="text-gray-700 hover:text-emerald-600 transition-colors"
                  >
                    (360) 206-7120
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 mb-5">
                <span className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-2xl text-gray-700"></i>
                </span>
                <div className="pt-1">
                  <a
                    href="mailto:husmamprollc@hotmail.com"
                    className="text-gray-700 hover:text-emerald-600 transition-colors"
                  >
                    husmamprollc@hotmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 mb-8">
                <span className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-gray-700"></i>
                </span>
                <div className="pt-1">
                  <a
                    href="https://www.google.com/maps/place/307+S+Steele+Ave,+Picayune,+MS+39466"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-700 hover:text-emerald-600 transition-colors"
                  >
                    307 S Steele Ave
                    <br />
                    Picayune, MS 39466
                  </a>
                </div>
              </div>

              <div className="flex flex-col gap-4">
                <Link
                  to="/pool-quote"
                  className="inline-flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-6 py-3 rounded-md text-sm transition-colors whitespace-nowrap w-fit"
                >
                  <i className="ri-file-list-3-line"></i>
                  Request A Pool Quote
                </Link>
              </div>
            </div>

            {/* Right - Map */}
            <div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d53173.62723038791!2d-89.7342937!3d30.5270716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x889c429f0df93625%3A0x4d9d4a4f4e2e0b5d!2s307%20S%20Steele%20Ave%2C%20Picayune%2C%20MS%2039466!5e0!3m2!1sen!2sus!4v1715443200000!5m2!1sen!2sus"
                width="100%"
                height={450}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="ATLAS PRO SERVICES LLC Location"
                className="rounded-lg"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}